import { render, staticRenderFns } from "./line-item.vue?vue&type=template&id=51b6ca82&scoped=true&lang=pug&"
import script from "./line-item.vue?vue&type=script&lang=coffee&"
export * from "./line-item.vue?vue&type=script&lang=coffee&"
import style0 from "./line-item.vue?vue&type=style&index=0&id=51b6ca82&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b6ca82",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductVisual: require('/opt/build/repo/library/components/globals/product-visual.coffee').default,SmartLink: require('/opt/build/repo/nuxt-app/components/globals/smart-link.coffee').default,FormSubscriptionIntervalSelector: require('/opt/build/repo/library/components/globals/form/subscription-interval-selector.vue').default,VinegarWarning: require('/opt/build/repo/library/components/globals/vinegar-warning.vue').default})
